<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="1"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="presiList.length">
              <div class="presi_con">
                <div
                  class="presi_character"
                  v-for="(chara, index) in presiList"
                  :key="index"
                  @click="toDetail(chara.id)"
                >
                  <div class="presi_img">
                    <img class="zoom-image" :src="chara.coverImg" />
                  </div>
                  <div class="presi_content">
                    <p class="presi_title">{{ chara.title }}</p>
                  </div>
                </div>
                <!-- <div class="more">MORE</div> -->
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="2"
          :cloumnId="cloumnId"
          :contentBg="contentBg2"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="presi_con">
                <div
                  class="presi_character"
                  v-for="(chara, index) in presiList"
                  :key="index"
                  @click="toDetail(chara.id)"
                >
                  <div class="presi_img"><img :src="chara.coverImg" /></div>
                  <div class="presi_content">
                    <p class="presi_title">{{ chara.title }}</p>
                  </div>
                </div>
                <!-- <div class="more">MORE</div> -->
              </div>
            </div>
          </div></AppcontentList
        >
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { presidumTab } from '@/const';
import { fetchConentList } from '@/assets/api';
export default {
  name: 'ArtCommittee',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      currentIndex: 0,
      page: { current: 1, size: 10, total: 20 },
      tabList: presidumTab,

      cloumnId: null,
      presiList: [
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
          id: 1,
        },

        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: true,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: false,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: false,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
        {
          img: require('../../assets/img/presi_character1.png'),
          name: '陈向宏',
          promoter: false,
          actor: '乌镇戏剧节主席',
          id: 1,
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.getList();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
    },
    currentChange(e) {
      this.current = e;
      this.getList();
    },
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: this.page.size,
        current: this.page.current,
      };
      fetchConentList(data).then((res) => {
        this.presiList = res.records;
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/presidiumDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 3.75rem 0 0;

    .presi_con {
      display: grid;
      grid-template-columns: repeat(7, 1fr); /* 5列，等分剩余空间 */
      gap: 10px; /* 可选：设置间距 */
      // padding-bottom: 4.6875rem;
      .presi_character {
        // width: 13.5%;
        // height: 23.3125rem;
        margin-bottom: 2.5rem;
        .presi_img {
          width: 100%;
          height: 19.6875rem;
          border-radius: 0.5rem 0.5rem 0 0;
          overflow: hidden;
          img {
            width: 100%;
            height: 19.6875rem;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
        }

        .presi_content {
          width: 100%;
          padding: 0.8rem 1.375rem;
          height: 3.625rem;
          background: url('../../assets/img/homeimgs/presi_content_bg.png')
            no-repeat left bottom/100% 100%;
          .presi_title {
            color: #fff;
            font-size: 1.125rem;
            font-family: SourceHanSansCN-Medium;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
      .more {
        width: 100%;
        text-align: center;
        color: #424451;
        font-size: 1rem;
        text-decoration: underline;
        margin-top: 1.3333rem;
        cursor: pointer;
      }
    }
  }
  .app_content_top {
    width: 100%;
    box-sizing: border-box;
    padding: 2rem 0;
    min-height: 57.5vh;
    .presi_con {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 3px;
      padding-bottom: 4.6875rem;
      .presi_character {
        width: calc((100% - 0.5rem) / 3);
        height: 20.25rem;
        margin-bottom: 0.25rem;
        cursor: pointer;
        .presi_img {
          width: 100%;
          height: 17.0833rem;
          border-radius: 0.3333rem 0.3333rem 0 0;
          overflow: hidden;
          img {
            width: 100%;
            height: 17.0833rem;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
        }

        .presi_content {
          width: 100%;
          padding: 0.6rem 1.375rem;
          height: 3.1667rem;
          background: url('../../assets/img/appImg/presi_content_bg.png')
            no-repeat left bottom/100% 100%;
          .presi_title {
            color: #fff;
            font-size: 1rem;
            font-family: SourceHanSansCN-Medium;

            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
      &::after {
        content: '';
        flex: auto;
        width: calc((100% - 0.5rem) / 3);
        /* 或者使用固定宽度，与项目宽度相同 */
        /* width: 30%; */
      }
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat center
    center fixed;
  background-size: cover;
}
</style>
